import React from 'react';
import { useTranslation } from 'next-i18next';
import { ButtonFW, FormWrapper } from 'components/Form/SignInForm.styled';
import { ArrowIcon } from '../../icons';
import { MODAL_NAME, AUTH_PATHS } from 'utils';
import { useRouter } from 'next/router';
import { useCartContext, useModalContext } from 'context';
import { useLaptop } from 'hooks';
import { FormConfirmHeader } from '..';

export const SuccessForm = () => {
  const { t } = useTranslation();
  const router = useRouter();
  const { isOverLaptop } = useLaptop();

  const { isProductInTheCart } = useCartContext();
  const { onOpenModal } = useModalContext();

  const handleClick = () => {
    // * if mobile and cart is empty
    if (!isOverLaptop || !isProductInTheCart) {
      return router.push(AUTH_PATHS.signIn);
    } else {
      onOpenModal(MODAL_NAME.signIn);
    }
  };

  return (
    <FormWrapper>
      <FormConfirmHeader
        title={t('app.auth.success')}
        subTitle={t('app.auth.thanks')}
      />
      <ButtonFW
        onClick={handleClick}
        endIcon={<ArrowIcon />}
        sx={{ maxWidth: '278px', alignSelf: 'center' }}
      >
        {t('app.sign_in')}
      </ButtonFW>
    </FormWrapper>
  );
};
